import EventPublisher from '../event_publisher';
import { CELL_SIZE } from './render_properties';

export default class GroupSelection {
  constructor(selectionGroup, selectionObjects) {
    this.selectionGroup = selectionGroup;
    this.selectionObjects = selectionObjects;
    this.selectionGroupInitialLeft = this.selectionGroup.left;
    this.selectionGroupInitialTop = this.selectionGroup.top;
    this.key = 'group-selection';
  }

  static fromCanvas(canvas) {
    return new GroupSelection(
      canvas.getActiveObject(),
      canvas.getActiveObjects()
    )
  }

  turnOffControls() {
    this.selectionGroup.hasControls = false;
    return this;
  }

  setupListeners() {
    this.selectionGroup.on('moving', this.onMoving);
    this.selectionGroup.on('modified', this.onModified);
    this.selectionObjects.forEach(obj => obj.fire('selection:created'));
  }

  onModified = event => {
    if (event.action === 'drag') {
      this.onMoved(event)
    }
  }

  tearDownListeners() {
    this.selectionGroup.off('moving');
  }

  topRightX() {
    const { tr } = this.selectionGroup.calcOCoords();
    const result = tr.x / CELL_SIZE;
    return result;
  }

  bottomLeftY() {
    const { bl } = this.selectionGroup.calcOCoords();
    const result = bl.y / CELL_SIZE;
    return result;
  }

  onMoved = () => {
    const { left, top } = this.selectionGroup;
    const leftOffset = left - this.selectionGroupInitialLeft;
    const topOffset = top - this.selectionGroupInitialTop;
    this.selectionObjects.forEach(object => object.fire('selection:moved', { leftOffset, topOffset }));
  }

  onMoving = () => {
    EventPublisher.publish('object-moving', { object: this });
  }
}
